import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _LabourType } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { _OfficialBook, _ProductionResource } from '../../../core/services/dataBean/EntityCatalogVdos';
import { CompanyEditor } from '../cellEditor/Company/CompanyEditor';
import { BasicButton } from '../../theme/Component/BasicButton';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const OfficialBookEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_OfficialBook)
    const [id, setID] = useState(null);
    const [conpany, setCompany] = useState<number>(null);
    const modal = useModal("Libros Oficiales de Contabilidad", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDOfficialBook == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getOfficialBookCatalog(conpany).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDOfficialBook', visible: true },
        { title: 'Compañia', property: 'CompanyName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Nombre del Reporte', property: 'HeaderReportName', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Libros Oficiales de Contabilidad"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <CompanyEditor id={conpany} onchange={(e: any) => { setCompany(e) }}></CompanyEditor>
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-search-line" clase="primary" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDOfficialBook); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}